// extracted by mini-css-extract-plugin
export var resizer = "_gr-0";